module.exports = __webpack_public_path__ + "img/no_zone_selected.0490519a.svg";